import React, { Suspense, lazy } from "react";
import "./Home.scss";

const TopBanner = lazy(() => import("./InnerSections/TopBanner"));
const OurClients = lazy(() => import("./InnerSections/OurClients"));
const AboutUs = lazy(() => import("./InnerSections/AboutUs"));
const Culture = lazy(() => import("./InnerSections/Culture"));
const WhatWeDoNew = lazy(() => import("./InnerSections/WhatWeDoNew"));
const HowWeEngage = lazy(() => import("./InnerSections/HowWeEngage"));
const Industry = lazy(() => import("./InnerSections/Industry"));
const ServicesNew = lazy(() => import("./InnerSections/ServicesNew"));
const Technologies = lazy(() => import("./InnerSections/Technologies"));
const Process = lazy(() => import("./InnerSections/Process"));
const Blog = lazy(() => import("./InnerSections/Blog"));
const GetinTouch = lazy(() => import("./InnerSections/GetinTouch"));

const SectionLoader = () => <div className="section-loader" />;

function Home() {
  return (
    <>
      <Suspense fallback={<SectionLoader />}>
        <TopBanner />
      </Suspense>

      <Suspense fallback={<SectionLoader />}>
        <OurClients />
        <AboutUs />
        <Culture />
        <WhatWeDoNew />
        <HowWeEngage />
        <Industry />
        <ServicesNew />
        <Technologies />
        <Process />
        <Blog />
        <GetinTouch />
      </Suspense>
    </>
  );
}

export default React.memo(Home);
